export const PROPERTY_TYPE_LABELS = {
  house: 'Casa',
  apartment: 'Apartamento',
  land: 'Terreno',
  loft: 'Loft',
  warehouse: 'Galpão',
  store: 'Loja',
  building: 'Prédio',
  office: 'Sala',
  farm: 'Sítio',
  countryHouse: 'Chácara',
  commercial: 'Comercial',
  rural: 'Rural',
  industrial: 'Industrial'
};

export const getPropertyTypeLabel = (type) =>
  (type && PROPERTY_TYPE_LABELS[type]) || type || '';

const localSlugify = (text) =>
  String(text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/**
 * Mapa de slug (singular e plural) para a chave interna do tipo.
 * Permite URLs como /propriedades/campo-grande/casa e /casas.
 */
export const PROPERTY_TYPE_SLUG_TO_KEY = (() => {
  const map = {};
  Object.entries(PROPERTY_TYPE_LABELS).forEach(([key, label]) => {
    const labelSlug = localSlugify(label);
    const keySlug = localSlugify(key);
    [labelSlug, keySlug].forEach((slug) => {
      if (!slug) return;
      map[slug] = key;
      // plural simples (casa -> casas, comercial -> comerciais)
      map[`${slug}s`] = key;
      if (slug.endsWith('l')) map[`${slug.slice(0, -1)}is`] = key;
      if (slug.endsWith('o')) map[`${slug.slice(0, -1)}oes`] = key;
    });
  });
  return map;
})();

export const getPropertyTypeBySlug = (slug) =>
  (slug && PROPERTY_TYPE_SLUG_TO_KEY[String(slug).toLowerCase()]) || null;

export const isPropertyTypeSlug = (slug) => Boolean(getPropertyTypeBySlug(slug));
